import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  container: {
    background: theme.white,
    borderRadius: theme.radius.md,
    padding: theme.other.spacing._16,

    '&.isCompact': {
      paddingTop: 0,
    },
  },

  balanceRow: {
    width: '100%',
    paddingBottom: theme.other.spacing._8,

    '&.isCompact': {
      minHeight: 48,
    },

    '&:not(:first-of-type):not(.noBorderTop)': {
      paddingTop: theme.other.spacing._8,
      borderTop: `1px solid ${theme.colors.gray2[0]}`,
    },

    '&.noBorderTop': {
      borderTop: 'none',
    },
  },

  balanceTitle: {
    color: theme.colors.gray2[6],
  },

  infoIcon: {
    color: theme.colors.gray[6],
    cursor: 'pointer',

    '&:hover': {
      color: theme.colors.gray2[6],
    },
  },

  dollarAmount: {
    color: theme.colors.gray2[6],
  },

  centsAmount: {
    color: theme.colors.gray2[6],
    alignSelf: 'flex-start',
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ '-2px',
  },

  tooltip: {
    marginRight: theme.other.spacing._8,
  },

  // Cash Balance Row styles
  cashRow: {
    width: '100%',
  },

  cashLabelGroup: {
    alignSelf: 'flex-start',
    paddingTop: theme.other.spacing._4,
  },

  cashAmountColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.other.spacing._2,
  },

  withdrawableSubtext: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer', // Always clickable when visible (only rendered when hasPlaythroughCash)
  },

  withdrawableText: {
    color: theme.colors.gray2[6],
  },

  dropdownChevron: {
    color: theme.colors.gray2[6],
    transition: 'transform 200ms ease',

    '&.isOpen': {
      transform: 'rotate(180deg)',
    },
  },

  playthroughDropdown: {
    backgroundColor: theme.colors.gray2[0],
    borderRadius: theme.radius.md,
    padding: theme.other.spacing._16,
    marginTop: theme.other.spacing._8,
    marginBottom: theme.other.spacing._8,
  },
}));
